import { CustomInput } from 'reactstrap'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 15px;
`
export const customStyles = {
  headCells: {
    style: {
      backgroundColor: '#F3F2F7',
      color: '#5E5873',
      fontWeight: '600',
      fontSize: '1rem',
    },
  },
}

export const Loading = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 8rem;
  background-color: rgba(0, 0, 0, 0.1);
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const StyledSelect = styled(CustomInput)`
  max-width: 150px;
  margin-right: 0.5rem;
`

export const StyledSwitch = styled(CustomInput)`
  display: flex;
  flex-direction: row-reverse;

  span {
    margin-right: 10px;
  }
`
